import { render, staticRenderFns } from "./DescriptorsContainer.vue?vue&type=template&id=407b79a9&scoped=true"
import script from "./DescriptorsContainer.vue?vue&type=script&lang=js"
export * from "./DescriptorsContainer.vue?vue&type=script&lang=js"
import style0 from "./DescriptorsContainer.vue?vue&type=style&index=0&id=407b79a9&prod&scoped=true&lang=css"
import style1 from "./DescriptorsContainer.vue?vue&type=style&index=1&id=407b79a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407b79a9",
  null
  
)

export default component.exports